import React from 'react';
import './sass/App.scss';
import { Describe } from './view/describe/Describe';
import { Features } from './view/features/Features';
import { Footer } from './view/footer/Footer';
import { Headr } from './view/header/Headr';
import { Navbar } from './view/navbar/Navbar';
import { VideoPlayer } from './view/video/VideoPlayer';
import { ThemeContext } from './theme/DarkMode';
import { Contact } from './view/contact/Contact';
import { useTranslation } from 'react-i18next';
import { Exon } from './view/exon/Exon';
import { Route, Routes } from 'react-router-dom';
import { Privacy } from './view/privacy/Privacy';
import { Guide } from './view/guide/Guide';

function App() {
  const { theme } = React.useContext(ThemeContext)
  const { i18n } = useTranslation();

  React.useEffect(() => {
    // Detect browser language
    const browserLang = navigator.language || navigator.userLanguage;
    const isPersian = browserLang.startsWith('fa') || browserLang.startsWith('ar');
    
    // Set language and direction
    i18n.changeLanguage(isPersian ? 'fa' : 'en');
    document.body.dir = isPersian ? 'rtl' : 'ltr';
    
    // Set initial title based on detected language
    document.title = isPersian 
      ? "اپلیکیشن آهیل - آینده را برنامه ریزی کن"
      : "Ahil Application | Planing the future";
  }, [i18n]) // Add i18n as a dependency to ensure title updates when language changes

  return (
    <div className={theme === 'light' ? 'light-App' : 'App'} id='top'>
      <Routes>
        <Route path='/' exact element={
          <>
            <Navbar />
            <Headr />
            <VideoPlayer />
            <Describe />
            <Features />
            <Exon />
            <Contact />
            <Footer />
          </>
        } />
        <Route path='/privacy' element={
          <>
            <Navbar />
            <Privacy />
            <Footer />
          </>
        } />
        <Route path='/guide' element={
          <>
            <Navbar />
            <Guide />
            <Footer />
          </>
        } />
      </Routes>
    </div>
  );
}

export default App;
